<template>
  <MainWrapper>
    <div class="companies-control-panel mb-30">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="companies-control-panel-inner">
              <router-link :to="'/companies/'+$route.params.slug+'/admin'" class="mr-20">
                <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'arrow-circle-left']" />
                <span class="dark-body-text panel-body-text">Назад к компании</span>
              </router-link>
              <router-link
                :to="'/companies/'+$route.params.slug+'/admin/specialists/'+spec_slug+'/settings'"
                class="mr-20"
              >
                <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'user-circle']" />
                <span class="dark-body-text panel-body-text">Основные настройки</span>
              </router-link>
              <router-link
                :to="'/companies/'+$route.params.slug+'/admin/specialists/'+spec_slug+'/schedule'"
                class="mr-20"
              >
                <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'cog']" />
                <span class="dark-body-text panel-body-text">Настройки расписания</span>
              </router-link>
              <router-link
                :to="'/companies/'+$route.params.slug+'/admin/specialists/'+spec_slug"
                class="mr-20"
              >
                <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'calendar-alt']" />
                <span class="dark-body-text panel-body-text">Календарь</span>
              </router-link>
              <div class="pointer pull-right">
                <span class="dark-body-text panel-body-text">{{ specInfo.full_name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="single-master-page">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="schedule-controls mb-20">
              <div
                class="button-left animated-shadow pointer round-button mr-10"
                @click="prevWeek"
              >
                <font-awesome-icon class="icon" :icon="['fal', 'angle-left']" />
              </div>
              <div
                class="button-right animated-shadow pointer round-button mr-30"
                @click="nextWeek"
              >
                <font-awesome-icon class="icon" :icon="['fal', 'angle-right']" />
              </div>
              <div class="input-wrapper mr-15" v-if="calendar_type === 'week'">
                <input
                  v-model="teleportDay"
                  @change="teleportSetTime"
                  class="rounded-input"
                  type="date"
                  placeholder="Переход на точную дату"
                />
              </div>
              <div class="input-wrapper mr-15">
                <select
                  v-model="spec_slug"
                  class="rounded-input spec-list-select"
                  @change="getSpecInfo"
                  :class="{spec_slug_disabled: cutBuffer}"
                  :disabled="cutBuffer"
                >
                  <option
                    v-for="(spec, i) in specialists"
                    :key="i"
                    :value="spec.slug"
                  >{{ spec.full_name }}</option>
                </select>
              </div>
              <div class="live-query-button-wrapper mr-15">
                <Button text="Напечатать" @click="onedayPrint" icon="print" />
              </div>
              <div v-if="copyBuffer === true" class="live-query-button-wrapper">
                <Button text="Отменить копирование" icon="ban" class="red" @click="cancelBuffer" />
              </div>
              <div v-if="cutBuffer === true" class="live-query-button-wrapper">
                <Button text="Отменить перемещение" icon="ban" class="red" @click="cancelBuffer" />
              </div>
              <div class="live-query-button-wrapper pull-right">
                <Button
                  text="Живая очередь"
                  @click="specModal = true; chosenDay = currentDay; registrator = true; live = true;"
                />
              </div>
              <div class="input-wrapper mr-15">
                  <CustomSelect @selected="selectCalendarTypeHandler"/>
                  <!-- <select
                    v-model="calendar_type"
                    class="rounded-input"
                    :class="{spec_slug_disabled: cutBuffer}"
                    :disabled="cutBuffer"
                  >
                    <option value="month">Месяц</option>
                    <option value="week">Неделя</option>
                  </select> -->
                </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <!-- <ScheduleAdmin ref="calendar" v-if="spec_slug !== '' && company.id > 0" :services="specInfo.service" :slug="spec_slug" :specialist="specInfo" :startDate="firstDay" :current_org="[company.id]" /> -->
            <Scheduler
              ref="scheduler"
              :type="calendar_type"
              :specSlug="spec_slug"
              :specInfo="specInfo"
              :company="company"
              :firstDay="firstDay"
              :date="date"
            />
          </div>
        </div>
      </div>
    </div>
    <RegisterTimeModal
      :date="chosenDay"
      :opened="specModal"
      v-on:reservation-created="reservationCreatedHandler"
      v-on:close-it="specModal = false"
      :org="this.company"
      :specialist="this.specInfo"
      :services="this.specInfo.service"
      v-on:choose-sect="(i) => this.chosenService = i"
      :periods="this.periods"
      :registrator="this.registrator"
      :live="this.live"
    ></RegisterTimeModal>
    <div
      v-if="print === true"
      style="position:absolute;top:0;left:0;width:100%;height:100%;background:#ffffff;padding:30px;z-index:999999"
    >
      <div id="printElement">
        <h3
          class="mb-10"
        >Список заявок {{ specInfo.full_name }} на {{ moment(teleportDay).format('DD.MM.YYYY') }}</h3>
        <table style="width:100%" border="1">
          <tr>
            <th style="padding:5px">Время приема</th>
            <th style="padding:5px">Клиент</th>
            <th style="padding:5px">Наименование</th>
            <th style="padding:5px">Контакты</th>
          </tr>
          <tr v-if="onedayOrders.length > 0" v-for="ord, i in onedayOrders" :key="i">
            <td style="padding:5px">{{ ord.date_time_reservation.split(' ')[1] }}</td>
            <td style="padding:5px">{{ ord.client_name }}</td>
            <td style="padding:5px">{{ ord.service }}</td>
            <td style="padding:5px">{{ ord.phone }}</td>
          </tr>
        </table>
      </div>
      <div class="mt-15">
        <div class="mr-10 inline-block">
          <Button type="blue" text="Печатать" @click="PrintMe('printElement')" />
        </div>
        <div class="inline-block">
          <Button type="gray" text="Отмена" @click="print = false" />
        </div>
      </div>
    </div>
  </MainWrapper>
</template>
<style lang="stylus" scoped>
@import '../../styles/main.core.vars.styl';

.spec-categories {
  padding: 20px 60px 30px 20px;
}

.spec-categories-header {
  display: flex;

  .spec-count {
    margin: 0 0 0 auto;
    color: $gray_text;
  }
}

.spec-categories-single {
  display: flex;
  align-items: center;

  >.icon {
    margin-left: auto;
    font-size: 16px;
  }
}

.companies-control-panel {
  margin-top: -30px;
  height: 56px;
  background: $black_text;

  .panel-body-text, .panel-icon {
    color: #fff;
  }

  &-inner {
    height: 56px;
    display: flex;
    align-items: center;
  }

  input {
    width: 430px;
  }
}

.col-lg-1 {
  min-height: 0;
}

.arr-down {
  position: absolute;
  bottom: -2px;
  width: 0;
  height: 0;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-bottom: 9px solid $black_text;
  z-index: 4;
  left: 0;
  right: 0;
  margin: auto;
}

.pull-right {
  margin-left: auto;
}

.schedule-controls {
  display: flex;
  align-items: center;
}

.spec_slug_disabled {
  background: #efefef;
}

.spec-list-select{
  width: 200px
}
</style>
<script>
import { Component, Vue, Watch } from "vue-property-decorator";
import { mapMutations, mapState } from "vuex";
import MainWrapper from "@/wrappers/MainWrapper.vue";
import Button from "@/components/Button.vue";
import Specialist from "@/components/Specialist.vue";
import Paginator from "@/components/Paginator.vue";
import ScheduleAdmin from "@/components/ScheduleAdmin.vue";
import RegisterTimeModal from "@/components/modals/RegisterTimeModal.vue";
import CustomSelect from '@/components/CustomSelect';
import { Scheduler } from "@/components/Scheduler";
import moment from "moment";
import http from "@/methods/http.ts";

@Component({
  components: {
    MainWrapper,
    Button,
    Specialist,
    Paginator,
    ScheduleAdmin,
    RegisterTimeModal,
    Scheduler,
    CustomSelect
  },
  methods: mapMutations(["changeCopyBuffer", 'changeCutBuffer']),
  computed: mapState(['copyBuffer', 'cutBuffer', 'reservations'])
})
export default class CompanyAdmin extends Vue {
  moment = moment;

  specModal = false;
  chosenCompany = {
    owner: ""
  };
  chosenDay = moment().format("DD.MM.YYYY");

  registrator = false;
  live = false;

  print = false;

  specialists = [];
  company = {
    id: 0
  };

  periods = [];

  specInfo = {
    rating: 0,
    categories: []
  };

  page = 1;
  pages = 0;
  search = "";

  spec_slug = "";

  orders = [];
  onedayOrders = [];

  date = new Date()
  calendar_type = "week";

  onedayPrint() {
    this.print = true;
    this.onedayOrders = [];
    this.orders = this.$refs.scheduler.$refs.calendar.orders;
    let timeArr = this.teleportDay.toString();
    timeArr = timeArr.split("-");
    let filteredData = timeArr[2] + "." + timeArr[1] + "." + timeArr[0];
    this.orders.map(o => {
      let rrr = o.date_time_reservation;
      let rrrArr = rrr.split(" ");
      if (rrrArr[0] === filteredData) {
        //let obj = o;
        //let timeArr = o.date_time_reservation.split(' ');
        //obj.date_time_reservation = timeArr[1];
        this.onedayOrders.push(o);
      }
    });
  }

  PrintMe(elm) {
    var disp_setting = "toolbar=yes,location=no,";
    disp_setting += "directories=yes,menubar=yes,";
    disp_setting += "scrollbars=yes,width=650, height=600, left=100, top=25";
    var content_vlue = document.getElementById(elm).innerHTML;
    var docprint = window.open("", "", disp_setting);
    docprint.document.open();
    docprint.document.write(
      '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"'
    );
    docprint.document.write(
      '"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">'
    );
    docprint.document.write(
      '<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">'
    );
    docprint.document.write("<head><title>My Title</title>");
    docprint.document.write('<style type="text/css">body{ margin:0px;');
    docprint.document.write("font-family:verdana,Arial;color:#000;");
    docprint.document.write(
      "font-family:Verdana, Geneva, sans-serif; font-size:12px;}"
    );
    docprint.document.write("a{color:#000;text-decoration:none;}");
    docprint.document.write("table{border:1px solid #000;} </style>");
    docprint.document.write('</head><body onLoad="self.print()"><center>');
    docprint.document.write(content_vlue);
    docprint.document.write("</center></body></html>");
    docprint.document.close();
    docprint.focus();
  }

  cancelBuffer() {
    if (this.cutBuffer === true) {
      this.cutBuffer = false;
      this.changeCutBuffer(false);
      this.$refs.calendar.cutBuffer = false;
    }
    if (this.copyBuffer === true) {
      this.copyBuffer = false;
      this.changeCopyBuffer(false);
      this.$refs.calendar.copyBuffer = false;
    }
  }

  nextWeek() {
    switch (this.calendar_type) {
      case "month":
        const nextMonth = moment(this.date)
          .add(1, "month")
          .format("YYYY-MM-DD HH:mm:ss");
        this.date = new Date(nextMonth);
        break;
      case "week":
        this.firstDay = moment(this.firstDay, "DD.MM.YYYY")
          .add(7, "d")
          .format("DD.MM.YYYY");

        let myDate = this.firstDay;
        myDate = myDate.split(".");
        this.teleportDay = myDate[2] + "-" + myDate[1] + "-" + myDate[0];
        break;
    }
  }

  prevWeek() {
    switch (this.calendar_type) {
      case "month":
        const prevMonth = moment(this.date)
          .subtract(1, "month")
          .format("YYYY-MM-DD HH:mm:ss");
        this.date = new Date(prevMonth);
        break;
      case "week":
        this.firstDay = moment(this.firstDay, "DD.MM.YYYY")
          .subtract(7, "d")
          .format("DD.MM.YYYY");

        let myDate = this.firstDay;
        myDate = myDate.split(".");
        this.teleportDay = myDate[2] + "-" + myDate[1] + "-" + myDate[0];
        break
    }
  }

  todayDay = moment().format("YYYY-MM-DD");
  teleportDay = moment().format("YYYY-MM-DD");
  firstDay = moment().format("DD.MM.YYYY");
  currentDay = moment().format("DD.MM.YYYY");

  teleportSetTime() {
    var myDate = this.teleportDay.split("-");
    this.$refs.calendar.ordersFillData = [];
    this.firstDay = myDate[2] + "." + myDate[1] + "." + myDate[0];
  }

  getCompany() {
    http(`companies/${this.$route.params.slug}`, "get", false, {}).then(r => {
      this.company = r.data;
      this.company.owner = r.data.name;
      this.getSpecialists();
    });
  }

  getSpecialists() {
    http("masters", "get", false, {
      page: this.page,
      org_id: this.company.id,
      page_size: 100,
      search: this.search
      //categories: this.chosenChildCategory || this.chosenCategory || undefined,
    }).then(r => {
      this.specialists = r.data.results;
      this.specialists.sort((spec1, spec2) => spec1.full_name > spec2.full_name ? 1 : -1)
      this.pages = Math.ceil(r.data.count / 100);
      this.specCount = r.data.count;
    });
  }

  getSpecInfo() {
    let url = "masters/" + this.spec_slug;
    this.firstDay = moment().format("DD.MM.YYYY");
    this.teleportDay = moment().format("YYYY-MM-DD");
    http(url, "get", false, {}).then(r => {
      this.specInfo = r.data;
    });
  }

  selectCalendarTypeHandler(value) {
    this.calendar_type = value
  }

  created() {
    this.spec_slug = this.$route.params.spec_slug;
    this.getCompany();
    this.getSpecInfo();
  }
}
</script>